import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AuthService } from '@shared/services/auth.service';
import { LocaleService } from '@shared/services/locale.service';

@Component({
	selector: 'app-logup',
	templateUrl: './logup.component.html',
	styleUrls: ['./logup.component.scss'],
})
export class LogupComponent implements OnInit {
	constructor(private route: ActivatedRoute, private title: Title, public locale: LocaleService, private auth: AuthService) {}

	redirect: string;
	fromPlaceAd: boolean = false;
	assignAd: string;
	queryPackage: string;
	embedded: string;
	fromPricing: string;
	isDealer: boolean = false;

	ngOnInit(): void {
		this.route.queryParams.subscribe((queries: Params) => {
			if (queries['redirect'] !== undefined) {
				this.redirect = queries['redirect'];
			}

			if (queries['from'] === 'pa') {
				this.fromPlaceAd = true;
				setTimeout(() => {
					this.auth.setToggleHeaderLogin(false);
				});
			}

			if (queries['from'] === 'pricing') {
				this.fromPricing = queries['from'];
			}

			if (queries['from'] === 'dealer') {
				this.isDealer = true;
			}

			if (queries['id'] !== undefined) {
				this.assignAd = queries['id'];
			}

			if (queries['package'] !== undefined) {
				this.queryPackage = queries['package'];
			}

			if (queries['embedded'] !== undefined) {
				this.embedded = queries['embedded'];
			}
		});

		this.title.setTitle(this.locale.translations['logup']['login']['n51'] + ' | ' + this.locale.translations['header']['n0']);
	}
}
